import { Grid, Row, Space } from 'antd'
import InvoiceTable from 'app/components/Core/Invoice/Table'
import TableAction from 'app/components/Core/Invoice/TableAction'
import KLink from 'app/components/Modules/KLink'
import Button from 'app/components/UI-Elements/General/Button'
import Icon from 'app/components/UI-Elements/General/Icon'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import TabBar from 'app/components/UI-Elements/Layout/TabBar/TabBar'
import { useCurrentContact } from 'app/lib/hooks/useCurrent'
import useFilterParams from 'app/lib/hooks/useFilterParams'
import useTitle from 'app/lib/hooks/useTitle'
import useTranslation from 'app/lib/hooks/useTranslation'
import ScriptService from 'app/lib/services/ScriptService'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'

import ClaimedToggle from './ClaimedToggle'
import DamageToggle from './DamageToggle'
import StatusToggle from './StatusToggle'

const Index: React.FC<PageProps> = (props) => {
  const { formatMessage } = useIntl()
  const { title } = useTitle(props)
  const { hubspot_sync, email } = useCurrentContact()
  const navigate = useNavigate()
  const { md } = Grid.useBreakpoint()
  const { tRoute } = useTranslation({ scope: props.route.key })
  const { params, setSearchParams, searchParams } = useFilterParams<{
    status: string
    damages: string
    claimed: boolean
  }>()

  useEffect(() => {
    ScriptService.embedHubspotScript(email, hubspot_sync)
  }, [email, hubspot_sync])

  const onRowClick = (record: IInvoice) => {
    navigate({
      pathname: Routes.Invoice.member(record.id.toString()).show,
      search: searchParams.toString()
    })
  }

  const onStatusFilter = (value: string) => {
    setSearchParams({ ...params, status: value })
  }

  const onDamagesFilter = (value: string) => {
    setSearchParams({ ...params, damages: value })
  }

  const onClaimedFilter = (value: boolean) => {
    setSearchParams({ ...params, claimed: value })
  }

  return (
    <Choose>
      <When condition={!md}>
        <Row gutter={[0, 40]}>
          <KCol span={24} />
          <KCol span={24} />
          <KCol span={24} card>
            <Row className="text-center" gutter={[0, 24]}>
              <KCol span={24}>
                <Icon type="monitor" />
              </KCol>
              <KCol span={24}>
                <span className="text-gray">{tRoute({ id: 'mobile_description' })}</span>
              </KCol>
              <KCol span={24}>
                <KLink to={Routes.Rental.collection().index}>
                  <Button title={tRoute({ id: 'to_rentals' })} type="primary" />
                </KLink>
              </KCol>
            </Row>
          </KCol>
        </Row>
        <TabBar />
      </When>
      <Otherwise>
        <Row gutter={[0, 24]}>
          <KCol span={24} card title={title}>
            <InvoiceTable
              showSearch
              filters={
                <Space>
                  <StatusToggle onFilter={onStatusFilter} value={params?.status} />
                  <DamageToggle onFilter={onDamagesFilter} value={params?.damages} />
                </Space>
              }
              filtersExtra={
                // Enable the filter only when migration is ready
                <If condition={false}>
                  <ClaimedToggle onFilter={onClaimedFilter} value={params?.claimed} />
                </If>
              }
              params={{ filters: params }}
              onRowClick={onRowClick}
              extraColumns={[
                {
                  ellipsis: true,
                  title: formatMessage({ id: 'project' }),
                  dataIndex: 'reference'
                },
                {
                  title: formatMessage({ id: 'component.core.table.invoice.actions' }),
                  className: 'td-action',
                  fixed: 'right',
                  width: 170,
                  render: (_: string, record) => <TableAction member={record} />
                }
              ]}
            />
          </KCol>
        </Row>
      </Otherwise>
    </Choose>
  )
}

export default Index
